import { deleteApi, getApi, postApi, putApi, putUploadImagesApi } from "../helpers/auth_helpers";

const base = process.env.REACT_APP_SERVERURL || "";

const CERT_IMAGE_MAX_BYTES = 8 * 1024 * 1024;

const certImageMime = (file: File): string => {
  const mime = file?.type || "";
  const name = String(file?.name || "").toLowerCase();
  if (mime === "image/png" || name.endsWith(".png")) {
    return "image/png";
  }
  if (
    mime === "image/jpeg" ||
    mime === "image/jpg" ||
    name.endsWith(".jpg") ||
    name.endsWith(".jpeg")
  ) {
    return "image/jpeg";
  }
  return "";
};

export const listCerts = (params: {
  offset?: number;
  limit?: number;
  kind?: string;
}) => {
  const q = new URLSearchParams();
  q.set("offset", String(params.offset ?? 0));
  q.set("limit", String(params.limit ?? 10));
  if (params.kind) q.set("kind", params.kind);
  return getApi(`${base}/geo/certs?${q.toString()}`);
};

export const getCert = (id: string) => getApi(`${base}/geo/certs/${id}`);

export const listCertKinds = () => getApi(`${base}/geo/certs/kinds`);

export const createCert = (body: Record<string, unknown>) =>
  postApi(`${base}/geo/certs`, body);

export const updateCert = (id: string, body: Record<string, unknown>) =>
  putApi(`${base}/geo/certs/${id}`, body);

export const deleteCert = (id: string) => deleteApi(`${base}/geo/certs/${id}`, {});

export const uploadCertImage = async (file: File): Promise<string> => {
  const mime = certImageMime(file);
  if (!mime) {
    throw new Error("Upload a JPEG or PNG picture");
  }
  if (file.size > CERT_IMAGE_MAX_BYTES) {
    throw new Error("Picture must be 8 MB or smaller");
  }
  const presigned: any = await postApi(`${base}/upload/geoCertImagePresignedURL`, {
    fileType: mime,
  });
  const presignedUrl: string = presigned?.data;
  if (!presigned?.success || !presignedUrl) {
    throw new Error(presigned?.message || "Could not get upload URL");
  }
  const putRes: any = await putUploadImagesApi(presignedUrl, file, {
    "Content-Type": mime,
  });
  if (putRes && putRes.ok === false) {
    throw new Error("Could not upload the certificate picture");
  }
  return String(presignedUrl).split("?")[0];
};
